import React from 'react'
import { ShieldCheck } from 'lucide-react'

type DutiesPaidNoticeProps = {
    className?: string
}

/** Shown under the totals where we pay the import duties (countries with an Import & handling fee). */
const DutiesPaidNotice: React.FC<DutiesPaidNoticeProps> = ({ className = '' }) => (
    <div role="note" className={`flex items-center gap-3 rounded-xl bg-green/10 px-3 py-2.5 ${className}`}>
        <ShieldCheck className="h-6 w-6 shrink-0 text-green" aria-hidden="true" />
        <div className="min-w-0 leading-snug">
            <p className="font-medium text-darkGreen">We pay the duties</p>
            <p className="text-sm text-green">What you see is what you pay</p>
        </div>
    </div>
)

export default DutiesPaidNotice
